<template>
    <div class="h-100">
        <front-table :front_page="page"
                     :front_records="records"
                     :front_search="search"
                     :front_header="header"
                     :model="model"
                     @reload="handleReload"
                     @edit="handleEdit"
                     @review="handleReview"
                     :btn_add="false"
                     btn_review
                     past
        >
        </front-table>
        <meeting-view v-mobile-dialog :view_mode="view_mode" :single="single" @start="startMeeting" @mail="mailAttendees"
                      @cancel="view_mode = false">
        </meeting-view>

    </div>
</template>

<script>

import FrontTable from "@/components/front-mobile-jwb-table";
import MyMeetingMixins from "@/views/mixins/my-meeting"
import MeetingView from "@/components/meeting-view";

export default {
    name: "meetings",
    mixins: [MyMeetingMixins],
    components: {MeetingView, FrontTable},
    created() {
        this.model = 'Meeting';
    },
    methods: {
        startMeeting() {
            this.$api(this.model + '.Host', {id: this.single.id, review: true}, true).then(res => {
                let host_url = res.data.data.host_url;
                //window.open(host_url, '_blank');
                window.location.href = host_url;
                this.view_mode = false;
            });
        },
        mailAttendees() {
            let vm=this;
            this.$api(this.model + '.Mail.Attendee', {id: this.single.id}, true).then(() => {
                vm.$messageBox.success("邮件已经发送给参会者!");
            });
        },
        handleEdit(id) {
            if (id == 0) {
                this.$router.push('/new');
            } else {
                this.$router.push('/edit/' + id);
            }
        },
        handleUpdate(single){
            this.single = this.$set(this,'single',single);
            const vm=this;
            this.$api(this.model+'.UpdatePoll',single,true).then(()=>{
                vm.$notice.success('更新完成!');
                vm.poll_view = false;
            });
        },
    },
    mounted() {
        window.scrollTo(0,0);
    },


}
</script>

<style scoped>

</style>
